import React from "react";

// Pass-through guard for the Career Connect module (a place to add a
// placement-officer permission check later). Mirrors AssetmanagementRoute.
const CareerRoute = ({ children }) => {
  return children;
};

export default CareerRoute;
